import styled from "styled-components";

export const ExportImageInputWrapper = styled.div`
  display: flex;
  gap: 20px;
  margin: 10px 0;
  align-items: center;
`;
